import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import './action-sheet.css';

export type SheetAction = {
  key: string;
  label: string;
  hint?: string | undefined;
  icon: ReactNode;
  tone?: 'normal' | 'brand' | 'danger';
  onSelect: () => void;
};

/**
 * Ações de um item (segurar na lista): quem é no topo e poucas ações, as que fazem
 * diferença naquele item. Fecha tocando fora ou em Cancelar.
 */
export function ActionSheet({
  title,
  subtitle,
  avatar,
  actions,
  onClose,
}: {
  title: string;
  subtitle?: string;
  avatar?: ReactNode;
  actions: SheetAction[];
  onClose: () => void;
}) {
  return createPortal(
    <div className="acts-wrap" onClick={onClose} role="presentation">
      <div
        className="acts"
        role="dialog"
        aria-label={`Ações para ${title}`}
        onClick={(event) => event.stopPropagation()}
      >
        <span className="acts-grip" aria-hidden="true" />
        <header className="acts-hd">
          {avatar && <span className="acts-av">{avatar}</span>}
          <span className="acts-who">
            <b>{title}</b>
            {subtitle && <small>{subtitle}</small>}
          </span>
        </header>
        <ul className="acts-list">
          {actions.map((action, index) => (
            <li key={action.key} style={{ animationDelay: `${40 + index * 35}ms` }}>
              <button
                type="button"
                className={`acts-it ${action.tone ?? 'normal'}`}
                onClick={() => {
                  onClose();
                  action.onSelect();
                }}
              >
                <span className="acts-ic" aria-hidden="true">
                  {action.icon}
                </span>
                <span className="acts-tx">
                  <b>{action.label}</b>
                  {action.hint && <small>{action.hint}</small>}
                </span>
              </button>
            </li>
          ))}
        </ul>
        <button type="button" className="acts-cancel" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>,
    document.body,
  );
}
